import { render } from "./FlipCard.vue?vue&type=template&id=93b8237e&scoped=true"
import script from "./FlipCard.vue?vue&type=script&lang=js"
export * from "./FlipCard.vue?vue&type=script&lang=js"

import "./FlipCard.vue?vue&type=style&index=0&id=93b8237e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93b8237e"]])

export default __exports__